const PREVIEW_STRIP_TOKENS = ['*', '`', '#']

export function sanitizeConversationPreview(
  text: string | null | undefined,
  { appendEllipsis = true }: { appendEllipsis?: boolean } = {},
): string | null {
  if (text == null) return null
  if (text === '') return ''

  const sanitized = PREVIEW_STRIP_TOKENS.reduce(
    (value, token) => value.replaceAll(token, ''),
    text,
  ).trim()

  if (!sanitized || !appendEllipsis) return sanitized
  if (sanitized.endsWith('...') || sanitized.endsWith('…')) return sanitized

  return `${sanitized}...`
}

export { PREVIEW_STRIP_TOKENS }
